import { render, staticRenderFns } from "./reporteMagistrado.vue?vue&type=template&id=1de5a37c"
import script from "./reporteMagistrado.vue?vue&type=script&lang=js"
export * from "./reporteMagistrado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports